import { type } from './type.js';

/**
 * @description
 * Checks if `value` is classified as an `Blob` object.
 *
 * @example
 * ``` ts
 * isBlob(new Blob());
 * // => true
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is a Blob object, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-blob
 */
export const isBlob = (value): value is Blob => {
  return type(value) === 'blob';
};
